import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { alphaNumericspace, getDateCombination, isImageValidPng, onlyNumeric } from '../../../commonClass/CommonValidation';
import { ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import CustomTable from '../../../../customControl/CustomTable';
import { useLocation } from 'react-router-dom';
import CommonFilter from '../../../../customControl/CommonFilter';

const DomesticPackage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { useredit, useradd, name, travelCategoryId, HomePageSectionId, folderName, section } = location.state || {};
    const userId = GetLocalStorage();
    const [countryCity, setCountryCity] = useState();
    const [themelist, setThemeList] = useState([]);
    const [city, setCity] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [formError, setFormError] = useState({});
    const [deletedImage, setDeletedImage] = useState([]);
    const [editDisable, setEditDisable] = useState(true)

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);

    const [formValue, setFormValue] = useState(
        {
            MerchandisingPackageId: 0,
            HomePageSectionId: HomePageSectionId,
            LocationId: 0,
            ThemeId: 0,
            ImageName: "",
            ImagePath: "",
            ImageFile: "",
            PackageDescription: "",
            PriceStartFrom: "",
            UserId: userId?.userMasterID,
        }
    )

    const getcountrystatecity = async () => {
        const countrystatecity = await getAllData(`/master/v1/getcountrystatecity`);
        if (countrystatecity?.status) {
            setCountryCity({
                countryData: countrystatecity?.data?.countryData?.map((contry) => ({ label: contry?.CountryName, value: contry?.CountryId })),
            });
        }
        dispatch(loaderActions.end());
    }

    const gettheme = async () => {
        const data = await getAllData(`/master/v1/getpackagetheme`);
        if (data?.status) {
            setThemeList(
                data?.data?.map((er) => ({ label: er?.ThemeName, value: er?.ThemeId })),
            );
        }
        dispatch(loaderActions.end());
    }

    const getcity = async (val) => {
        const city = await getAllData(`/master/v1/getcitybythemeid?themeId=${val}`);
        if (city?.status) {
            setCity(city?.data?.filter(er => er.CountryId === 1)?.map((el) => ({ label: el?.City, value: el?.LocationId })));
        }
        dispatch(loaderActions.end());
    }

    const getdatalist = async () => {
        const data = await getAllData(`/master/v1/getmerchandisingpackagelist?homePageSectionId=${HomePageSectionId}`);
        if (data?.status) {
            setDataList(data?.data)
            setFilterData(data?.data)
        }
        else {
            setDataList([])
            setFilterData([])
        }
        dispatch(loaderActions.end());
    }

    //#region List data
    useEffect(() => {
        dispatch(loaderActions.start());
        const fetchData = async () => {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let token = GetLocalStorage();
                if (token && token.userName && token.token) {
                    getdatalist();
                    getcountrystatecity();
                    gettheme();
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, []);

    const handleDropDown = (name, val) => {
        setEditDisable(false)
        setFormError({});
        if (name === 'ThemeId') {
            setFormValue((pre) => ({ ...pre, [name]: val.value, LocationId: 0 }));
            getcity(val?.value)
        }
        else {
            setFormValue((pre) => ({ ...pre, [name]: val.value }));
        }
    }
    const handleChange = (name, val) => {
        setEditDisable(false)
        setFormError({});
        setFormValue((pre) => ({ ...pre, [name]: val }));
    }

    const handleUploadImageLoad = (name, e) => {
        setEditDisable(false)
        setFormError({});
        let error = {}
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files[0];
            const filename = getDateCombination(files.name);
            setDeletedImage([...deletedImage, formValue?.ImagePath])
            setFormValue({
                ...formValue,
                ImageName: filename,
                ImagePath: `CMS/Merchandising/${folderName}/${section}/${filename}`,
                ImageFile: files,
            })
        }
        else {
            error.ImageName = 'Only PNG file type is accepted.';
            setFormError(error);
        }
        e.target.value = null
    }

    const checkValidation = () => {
        let errorMessages = {};
        let isError = true;

        if (!formValue?.ThemeId) {
            errorMessages['ThemeId'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (!formValue?.LocationId && formValue?.ThemeId) {
            errorMessages['LocationId'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (!formValue?.ImagePath) {
            errorMessages['ImageName'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        } else if (formValue?.ImageFile) {
            const files = formValue?.ImageFile;
            let fileSize = files.size / 1024;
            fileSize = fileSize / 1024
            if (!isImageValidPng(files.name) && files) {
                errorMessages['ImageName'] = 'Only PNG file type is accepted.'
                isError = false;
            } else if (fileSize > 5) {
                errorMessages['ImageName'] = 'Cannot upload file that exceeds 5 MB.'
                isError = false;
            }
        }
        if (formValue?.PackageDescription?.trim()?.length === 0) {
            errorMessages['PackageDescription'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (formValue?.PriceStartFrom?.toString()?.trim()?.length === 0) {
            errorMessages['PriceStartFrom'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }

        setFormError(errorMessages);
        return isError;
    }

    const onSubmitData = async () => {
        const isValid = checkValidation();
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (isValid) {
                dispatch(loaderActions.start());
                const updateNewsLetter = await postUsersData('/master/v1/insertorupdatemerchandisingpackage', formValue);
                if (updateNewsLetter.status) {
                    formValue?.ImageFile && await ImageUpload(`CMS/Merchandising/${folderName}/${section}/`, formValue?.ImageName, formValue?.ImageFile);
                    deletedImage.length > 0 && deletedImage.forEach(async (deletedImagePath) => await ImageDelete(deletedImagePath));
                    getdatalist();
                    onClearButton();
                    dispatch({ type: 'ALERTING', message: updateNewsLetter.message })
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch(loaderActions.end());
                    dispatch({ type: 'ALERTING', message: updateNewsLetter.message })
                    return;
                }
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const columns = [
        {
            name: 'Sr. No.',
            sortable: true,
            float: "left",
            minWidth: "20px",
            maxWidth: "20px",
            selector: (data, index) => index + 1,
        },
        {
            name: 'City',
            key: 'City',
            sortable: true,
            float: "left",
            selector: (data) => data?.City,
        },
        {
            name: 'Theme',
            key: 'ThemeName',
            sortable: true,
            float: "left",
            selector: (data) => data?.ThemeName,
        },
        {
            name: 'Price',
            key: 'PriceStartFrom',
            sortable: true,
            float: "left",
            selector: (data) => data?.PriceStartFrom,
        },
        {
            name: 'Edit',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'edit')} disabled={!useredit}
            ><i className="fa fa-edit eye-icon"></i></button>
        },
        {
            name: 'View',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'view')} ><i className="fa fa-eye" ></i></button>
        }
    ]

    const onEditorView = async (data, type) => {
        if (type === 'view') {
            setSerachDisable(true)
        }
        setEditDisable(true)
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const PFD = await getAllData(`/master/v1/getmerchandisingpackagebyid?merchandisingPackageId=${data?.MerchandisingPackageId}`);
            setFormError({});
            if (PFD?.status) {
                getcity(PFD?.data?.[0]?.ThemeId)
                setFormValue((form) =>
                ({
                    ...form,
                    MerchandisingPackageId: PFD?.data?.[0]?.MerchandisingPackageId,
                    HomePageSectionId: HomePageSectionId,
                    LocationId: PFD?.data?.[0]?.LocationId,
                    ThemeId: PFD?.data?.[0]?.ThemeId,
                    ImageName: PFD?.data?.[0]?.ImageName,
                    ImagePath: PFD?.data?.[0]?.ImagePath,
                    ImageFile: "",
                    PackageDescription: PFD?.data?.[0]?.PackageDescription,
                    PriceStartFrom: PFD?.data?.[0]?.PriceStartFrom,
                    UserId: userId?.userMasterID,
                    type: type
                }))
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
        dispatch(loaderActions.end());
    }

    const onClearButton = () => {
        setFormError({});
        setEditDisable(false);
        setSerachDisable(false)
        setFormValue(
            {
                HomePageSectionId: HomePageSectionId,
                LocationId: 0,
                ThemeId: 0,
                ImageName: "",
                ImagePath: "",
                ImageFile: "",
                PackageDescription: "",
                PriceStartFrom: "",
                UserId: userId?.userMasterID,
            }
        )
    }

    return (
        <>
            <div class="container-fluid mt-4 heading_color">
                <h3>{travelCategoryId === 1 ? 'Flights Merchandising' : 'Holiday Merchandising'}</h3>
            </div>
            <div class="container-fluid form_border pb-5 pt-4 my-3">
                <div className='px-xl-5'>
                    <div className=" heading_color mb-3">
                        <h4>{name}</h4>
                    </div>

                    <form action=" " className=' mb-5' >
                        <div className='row'>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Country</label>
                                    </div>
                                    <div class=" col-lg-8 col-md-12 col-sm-12">
                                        <div class="input-group">
                                            <Select
                                                id='FromCountryId'
                                                className="dropdown w-100 select_dropdown"
                                                options={countryCity?.countryData}
                                                value={countryCity?.countryData?.find((serachoption) => serachoption.value === 1) || null}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Theme</label>
                                    </div>
                                    <div class=" col-lg-8 col-md-12 col-sm-12">
                                        <div class="input-group">
                                            <Select
                                                id='ThemeId'
                                                className="dropdown w-100 select_dropdown"
                                                options={themelist}
                                                value={themelist?.find((serachoption) => serachoption?.value === formValue?.ThemeId) || null}
                                                onChange={(val) => handleDropDown("ThemeId", val)}
                                                isDisabled={formValue?.type === 'view' ? true : false}
                                            />
                                        </div>
                                        {formError?.ThemeId && <div className='text-danger text-start'>{formError?.ThemeId}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                        <label for="inputPassword6" class="col-form-label required">City</label>
                                    </div>

                                    <div class=" col-lg-8 col-md-12 col-sm-12">
                                        <div class="input-group">
                                            <Select
                                                className="dropdown w-100 select_dropdown"
                                                id='LocationId'
                                                options={city}
                                                value={city?.find((option) => option.value === formValue?.LocationId) || null}
                                                onChange={(val) => handleDropDown('LocationId', val)}
                                                isDisabled={formValue?.type === 'view' ? true : false || formValue?.ThemeId ? false : true}
                                            />
                                        </div>
                                        {formError.LocationId && <div className='text-danger text-start'>{formError.LocationId}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                        <label for="inputPassword6" class="col-form-label required">Images</label>
                                    </div>

                                    <div class=" col-lg-8 col-md-12 col-sm-12">
                                        <div class="input-group">
                                            <input
                                                type="file"
                                                name='FromImageName'
                                                id="FromImageName-id"
                                                className="form-control btn_add"
                                                accept=".png"
                                                onChange={(e) => handleUploadImageLoad('FromImageName', e)}
                                                disabled={formValue?.type === 'view' ? true : false}
                                            />
                                            <label class="input-group-text" htmlFor="FromImageName-id">Browse</label>
                                        </div>
                                        {formValue?.ImageName && <div className=' text-start w-100 text-break'>{formValue?.ImageName}</div>}
                                        {formError?.ImageName && <div className='text-danger text-start'>{formError?.ImageName}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                        <label for="inputPassword6" class="col-form-label required">Package Description</label>
                                    </div>

                                    <div class=" col-lg-8 col-md-12 col-sm-12">
                                        <div class="input-group">
                                            <input
                                                type="text" id="customer-name"
                                                class="form-control btn_add"
                                                placeholder="Package Description"
                                                maxLength={50}
                                                name='PackageDescription'
                                                onChange={(val) => handleChange('PackageDescription', alphaNumericspace(val.target.value))}
                                                value={formValue?.PackageDescription}
                                                disabled={formValue?.type === 'view' ? true : false}
                                            />
                                        </div>
                                        {formError?.PackageDescription && <div className='text-danger text-start'>{formError?.PackageDescription}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                        <label for="inputPassword6" class="col-form-label required">Price start From</label>
                                    </div>

                                    <div class=" col-lg-8 col-md-12 col-sm-12">
                                        <div class="input-group">
                                            <input
                                                type="text" id="customer-name"
                                                class="form-control btn_add"
                                                placeholder="Price start From"
                                                maxLength={7}
                                                name='PriceStartFrom'
                                                onChange={(val) => handleChange('PriceStartFrom', Number(onlyNumeric(val.target.value)) > 0 ? Number(onlyNumeric(val.target.value)) : "")}
                                                value={formValue?.PriceStartFrom}
                                                disabled={formValue?.type === 'view' ? true : false}
                                            />
                                        </div>
                                        {formError?.PriceStartFrom && <div className='text-danger text-start'>{formError?.PriceStartFrom}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <CommonFilter
                        columns={columns}
                        filterList={filterData}
                        searchDisabled={serchdisable}
                        getdata={getdatalist}
                        setlistdata={setDataList}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={dataList}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={false}
                    />

                    <div class="d-flex justify-content-center">
                        {
                            formValue?.type === 'edit'
                                ? (<button class="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={editDisable || !useredit}
                                >Update</button>
                                )
                                : (<button class="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={(formValue?.type === 'view' ? editDisable : false) || !useradd}
                                >Add</button>)
                        }

                        <button type="button" class="btn btn-primary mx-1" id="btnClear"
                            onClick={() => onClearButton({})}
                        >Clear</button>
                    </div>
                </div >
            </div >
        </>
    )
}

export default DomesticPackage